export default "__VITE_ASSET__BQX$dWDx__"